import modalConfirmation from '../shared/components/modal-response/modal-response.view.html';

let inject = [
    '$scope',
    'AccountService',
    '$state',
    '$rootScope',
    'SharedService',
    '$timeout',
    'ngAuthSettings',
    'CartService',
    'SessionService',
    'NgTableParams',
    '$mdToast',
    '$uibModal'
];

class AccountController {
    constructor($scope,
                AccountService,
                $state,
                $rootScope,
                SharedService,
                $timeout,
                ngAuthSettings,
                CartService,
                SessionService,
                NgTableParams,
                $mdToast,
                $uibModal) {
        this.$state = $state;
        this.SessionService = SessionService;
        this.ngAuthSettings = ngAuthSettings;
        this.CartService = CartService;
        this.NgTableParams = NgTableParams;
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.$rootScope = $rootScope;
        this.AccountService = AccountService;
        this.$uibModal = $uibModal;
        this.SharedService = SharedService;
        this.$mdToast = $mdToast;
        this.tabMyAccount = 1;
        this.updatingUserData = false;
        this.userDataUpdated = false;
        this.errorUpdatingUserData = '';
        this.errorsUpdatingUserData = [];
        this.currentPassword = '';
        this.password = '';
        this.passwordConfirmation = '';

        this.updatingPasswordData = false;
        this.passwordDataUpdated = false;
        this.errorUpdatingPasswordData = '';
        this.errorsUpdatingPasswordData = [];
        this.$scope.passwordStrength = 0;
        this.loadingUserInfo = false;
        this.loadedUserInfo = false;
        this.errorloadingUserInfo = false;

        this.accountDataForm = {
            gender: ''
        };

        this.passwordDataForm = {};
        this.advancedDataForm = {};
        this.avatarPhoto = "./assets/sitios/standard/img/img-user.png";
        this.gender = [];
    }

    $onInit() {
        this.getGenero();
        this.getUserInfo();
    }

    getUserInfo() {
        let globals = this.shCtrl.globals;
        let userId = '';
        try {
            userId = globals.currentUser.userId;
        } catch (e) {
        }

        this.loadingUserInfo = true;
        this.loadedUserInfo = false;
        this.errorloadingUserInfo = false;
        this.AccountService.getUserInfo({'userId': userId}).then(response => {
            this.loadingUserInfo = false;
            this.loadedUserInfo = true;
            this.errorloadingUserInfo = false;
            // Elementary info
            this.accountDataForm.firstName = response.userInfo.firstName;
            this.accountDataForm.middleName = response.userInfo.middleName;
            this.accountDataForm.lastName = response.userInfo.lastName;
            this.accountDataForm.surName = response.userInfo.surName;
            this.accountDataForm.email = response.userInfo.email;
            this.accountDataForm.IndicativeCity = response.userInfo.phoneIndicativeCity;
            this.accountDataForm.IndicativeCountry = response.userInfo.phoneIndicativeCountry;
            this.accountDataForm.typeId = response.userInfo.typeId;
            this.accountDataForm.numberId = response.userInfo.numberId;
            this.accountDataForm.numberIdUpdate = response.userInfo.numberIdUpdate;
            this.accountDataForm.emailConfirmation = response.userInfo.emailConfirmation;
            this.accountDataForm.phone = response.userInfo.phone;
            this.accountDataForm.movil = response.userInfo.movil;
            this.accountDataForm.indicative = response.userInfo.movilIndicative;
            this.accountDataForm.receiveInformation = response.userInfo.receiveInformation;
            this.accountDataForm.gender = response.userInfo.sex.toString();
            this.accountDataForm.city = response.userInfo.cityId;
            this.accountDataForm.searchLocationtext = response.userInfo.cityName;

            this.avatarPhoto = response.userInfo.avatar;
        }).catch(reason => {
            this.loadingUserInfo = false;
            this.loadedUserInfo = true;
            this.errorloadingUserInfo = true;
        });
    }

    updatePasswordData(form) {

        if (form.$valid) {
            let globals = this.shCtrl.globals;
            this.updatingPasswordData = true;
            this.passwordDataUpdated = false;
            this.errorUpdatingPasswordData = '';
            this.errorsUpdatingPasswordData = [];
            let userId = '';
            try {
                userId = globals.currentUser.userId;
            } catch (e) {
            }



            this.AccountService.passwordUpdate({
                'userId': userId,
              'currentPassword': form['currentPassword']['$viewValue'],
              'password': form['password']['$viewValue'],
              'passwordConfirmation': form['passwordConfirmation']['$viewValue'],
            }).then(response => {
                this.updatingPasswordData = false;

                if (!response.error) {
                    this.passwordDataUpdated = true;
                    if (__env.adaptative) {
                        this.messageMaterial('La contraseña ha sido actualizada exitosamente.');
                    }

                    this.$scope.currentPassword = '';
                    this.$scope.password = '';
                    this.$scope.passwordConfirmation = '';
                    this.passwordForm.$setUntouched();
                    this.passwordForm.$setPristine();

                }
                else {
                    this.errorUpdatingPasswordData = response.message;
                    this.errorsUpdatingPasswordData = response.errors;
                }
            }).catch(reason => {
                console.log(reason);
                this.updatingPasswordData = false;
                this.passwordDataUpdated = false;
                this.errorUpdatingPasswordData = "Ha ocurrido un error al actualizar la clave.";
            });
        }
        else {
            angular.forEach(form.$error.required, (field) => {
                field.$setDirty();
            });
        }
    }

    updateAccountData(dataToUpdate, typeInfo, form) {


        if (form.$valid) {
            let globals = this.shCtrl.globals;

            this.updatingUserData = true;
            this.userDataUpdated = false;
            this.errorUpdatingUserData = '';
            this.errorsUpdatingUserData = [];

            let userId = '';
            try {
                userId = globals.currentUser.userId;
            } catch (e) {
            }

            dataToUpdate.userId = userId;
            this.AccountService.userUpdate({'dataToUpdate': dataToUpdate, 'typeInfo': typeInfo}).then(response => {
                this.updatingUserData = false;

                if (!response.error) {
                    if (__env.adaptative) {
                        this.messageMaterial(response.message);
                    }else{
                      let options = {
                        title: 'Actualización exitosa',
                        isHtml: true,
                        content: response.message,
                        size: '',
                        showBottonCancel: false,
                        textActionCancel: '',
                        textAction: 'Aceptar'
                      };
                      this.messageResponse(options, "active");
                    }

                }
                else {
                    this.errorUpdatingUserData = response.message;
                    this.errorsUpdatingUserData = response.errors;
                }
            }).catch(reason => {
                this.updatingUserData = false;
                this.errorUpdatingUserData = "Ha ocurrido un error al actualizar el usuario.";
            });
        }
        else {
            let validations = "";
            angular.forEach(form.$error.required, (field) => {
                if (field.$$attr.mvalid) {
                    validations += '<li>' + field.$$attr.mvalid + '</li>';
                }
                field.$setDirty();
            });
            angular.forEach(form.$error.restEmail, function (field) {
              if(field.$$attr.mvalid){
                validations += '<li>' + field.$$attr.mvalid + '</li>' ;
              }
            });
            angular.forEach(form.$error.email, function (field) {
                if(field.$$attr.mvalid){
                    validations += '<li>' + field.$$attr.mvalid + '</li>' ;
                }
            });
            angular.forEach(form.$error.compareTo, function (field) {
                if(field.$$attr.mvalid){
                    validations += '<li>' + field.$$attr.mvalid + '</li>' ;
                }
            });
            angular.forEach(form.$error.minlength, function (field) {
                if(field.$$attr.mvalid){
                    validations += '<li>' + field.$$attr.mvalid + '</li>' ;
                }
            });
            if (this.accountDataForm.searchLocationtext &&  !this.accountDataForm.city ){
                validations += '<li> Debes buscar y seleccionar una ciudad. </li>' ;
            }

          let options = {
            title: 'Faltan algunos datos por diligenciar...',
            isHtml: true,
            content: `
                    <div>
                      <p>
                        Para continuar con este proceso debes diligenciar los siguientes datos:
                      </p>
                      <ul style="margin-top: 10px;list-style: inherit;margin-left: 30px;">
                        ${validations}
                      </ul>
                    </div>
                  `,
                size: '',
                showBottonCancel: false,
                textActionCancel: '',
                textAction: 'Aceptar'
            };
            this.messageResponse(options, "active");
        }
    }

    messageResponse(options, callAcept, callback, callCancel, callbackCancel) {
        let modalInstance = this.$uibModal.open({
            animation: true,
            template: modalConfirmation,
            controller: 'ModalResponseController',
            controllerAs: 'mdCtrl',
            size: options.size,
            resolve: {
                modalOptions: () => options
            }
        });
        modalInstance.result.then(() => {
            if (callAcept) {
                callback();
            }
        }).catch(reason => {
            if (callCancel) {
                callbackCancel();
            }
        });
    }

    getGenero() {
        this.AccountService.getGenero().then(data => {
            this.gender = data;
        });
    }

    getLocationsByFastSearch(searchLocationText) {

        this.accountDataForm.locationSelected = false;
        this.accountDataForm.locationsByFastSearch = [];
        this.accountDataForm.locationSelected = false;

        this.accountDataForm.country = '';
        this.accountDataForm.state = '';
        this.accountDataForm.city = '';

        this.accountDataForm.loadingLocationsByFastSearh = false;
        this.accountDataForm.loadedLocationsByFastSearch = false;
        this.accountDataForm.errorLoadingLocationsByFastSearch = false;

        try {
            if (searchLocationText.length > 3) {
                this.accountDataForm.loadingLocationsByFastSearh = true;
                this.CartService.locationBySearchText({
                    'searchText': searchLocationText,
                    'citiesERP': true
                }).then(response => {
                    this.accountDataForm.loadingLocationsByFastSearh = false;
                    this.accountDataForm.loadedLocationsByFastSearch = true;
                    this.accountDataForm.locationsByFastSearch = response;
                }).catch(reason => {
                    this.accountDataForm.loadingLocationsByFastSearh = false;
                    this.accountDataForm.loadedLocationsByFastSearch = true;
                    this.accountDataForm.errorLoadingLocationsByFastSearch = true;
                });
            }
        } catch (e) {
        }
    }

    setLocationCity(location) {

        this.accountDataForm.country = location.countryId;
        this.accountDataForm.state = location.stateId;
        this.accountDataForm.city = location.cityId;
        this.accountDataForm.locationSelected = true;
        this.accountDataForm.searchLocationtext = location.cityName + ', ' + location.stateName + ' - ' + location.countryName;
        this.accountDataForm.personIndicative = ((angular.isDefined(location.countryIndicative) && location.cityIndicative != "") ? location.countryIndicative : "") + " " + ((angular.isDefined(location.cityIndicative) && location.cityIndicative != "") ? location.cityIndicative : "");

    }

    messageMaterial(text) {
        var mdToast = this.$mdToast;
        this.$mdToast.show({
            hideDelay: 4000,
            controller: function () {
                this.closeToast = function () {
                    mdToast.hide();
                }

            },
            controllerAs: 'toast',
            template: '<md-toast>\n' +
            '  <span class="md-toast-text">' + text + '</span>\n' +
            '  <md-button ng-click="toast.closeToast()">\n' +
            '    Cerrar\n' +
            '  </md-button>\n' +
            '</md-toast>'
        });
    }
}

AccountController.$inject = inject;

export default AccountController;




/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/account/account.controller.js
 **/